// extracted by mini-css-extract-plugin
export var screen1__btns = "screen1-module--screen1__btns--03980";
export var screen1__date = "screen1-module--screen1__date--ada37";
export var screen1__doText = "screen1-module--screen1__do-text--fa34a";
export var screen1__info = "screen1-module--screen1__info--1e485";
export var screen1__innerContainer = "screen1-module--screen1__inner-container--cc349";
export var screen1__mainInfo = "screen1-module--screen1__main-info--cc7d3";
export var screen1__prBtn = "screen1-module--screen1__pr-btn--a09d8";
export var screen1__subtitle = "screen1-module--screen1__subtitle--8b195";
export var screen1__title = "screen1-module--screen1__title--2a4ca";